import { HomeWidgetController } from './home-widget.controller'

function homeWidget () {
  return {
    restrict: 'E',
    transclude: true,
    replace: true,
    scope: {
      link: '<',
      linkAction: '&',
      titleName: '@',
      count: '<'
    },
    templateUrl: '/home/directives/home-widget/home-widget-directive.html?$$REVISION$$',
    controller: HomeWidgetController
  }
}

export { homeWidget }
